import { render, staticRenderFns } from "./TimeStudyButton.vue?vue&type=template&id=1e80b8f3&scoped=true&"
import script from "./TimeStudyButton.vue?vue&type=script&lang=js&"
export * from "./TimeStudyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e80b8f3",
  null
  
)

export default component.exports